export default __webpack_public_path__ + "static/media/img-new-home-1-mobile.b7b5c67e.png";